import { PrivacyPolicy } from "../types";
import request from "./request";

import { privacyPolicyApi } from "../settings";

export const getPrivacyPolicy = (): Promise<PrivacyPolicy> => {
  return request(privacyPolicyApi);
};
